module.exports = __webpack_public_path__ + "static/media/scenario5_preview.729120fd.jpg";